import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-0eb2215d"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  id: "video-filter",
  "color-interpolation": "sRGB",
  "color-interpolation-filters": "sRGB",
  x: "0",
  y: "0",
  height: "100%",
  width: "100%"
}
const _hoisted_2 = ["values"]
const _hoisted_3 = ["values"]
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("feComposite", {
  operator: "arithmetic",
  in2: "SourceGraphic",
  k1: "8",
  k2: "0",
  k3: "1",
  k4: "0"
}, null, -1))
const _hoisted_5 = ["kernelMatrix"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("svg", null, [
    _createElementVNode("filter", _hoisted_1, [
      _createElementVNode("feColorMatrix", {
        type: "matrix",
        values: _ctx.bwColorKernel
      }, null, 8, _hoisted_2),
      _createElementVNode("feColorMatrix", {
        type: "matrix",
        values: _ctx.colorInvertKernel
      }, null, 8, _hoisted_3),
      _hoisted_4,
      _createElementVNode("feConvolveMatrix", {
        order: "5",
        kernelMatrix: _ctx.sharpeningKernel,
        edgeMode: "duplicate",
        result: "convo"
      }, null, 8, _hoisted_5)
    ])
  ]))
}